import { IManufacturer, IManufacturerPagedData } from './manufacturer'
import { IBrand } from './brand'
import { IUpload } from './upload'
import { ICategory, ICategoryPagedData } from './category'
import { Dispatch } from 'react'

export interface IProduct {
  _id?: string

  name: string
  description: string
  status: string
  /**
   * manufacturer_status && brand_status &&
   * product_status && seller_product_status
   */
  compound_status?: string

  sku_id: string
  case_count: number
  mpu: number
  price: number
  weight?: number
  size?: number
  quantity?: number

  upload_id: string
  upload?: IUpload

  sellers?: any
  manufacturer_id?: string
  manufacturer?: IManufacturer

  brand_id: string
  brand?: IBrand

  tags?: any

  pricetag?: IProductPricetag
}

export interface ISellerProduct {
  _id?: string
  mpu: number
  price: number
  quantity: number
  status: 'active' | 'inactive'
  /** Stored as JSON {discount, market_price} */
  meta: string
}

export enum ProductTag {
  LowerUnit = 'LOWER_UNIT',
  HigherUnit = 'HIGHER_UNIT',
  Markup = 'MARKUP',
  // MoreImage = 'MORE_IMAGE',
}

export interface IProductTag {
  _id?: string
  tag: ProductTag
  value: string
  product_id: string
}

export interface IProductPagedData {
  page: number
  total: number
  limit: number
  count: number

  data: IProduct[]
}

export interface IProductPricetag {
  mpu: number,
  price: number,
  case_count?: number,
}

export interface IProductContextState {
  loading: boolean,
  query: string,
  products: IProduct[],
  all_products: IProduct[],
  brands: IBrand[],
  // brands_dict: {},
  manufacturers: IManufacturer[],
  // route_fulfilments: {},
  active_brand: IBrand | null,
  active_manufacturer: IManufacturer | null,

  categories: ICategory[],

  search_context: any,
  search_result: any[],
  search_result_exact: any[],
  search_result_match: any[],
  product_view: 'list' | 'grid',
  product_view_default: 'list' | 'grid',
  seller_product: ISellerProduct[],
  // seller_product_dict: { [_id: string]: ISellerProduct },
  seller_product_dict: any,
  error: any,

  product_page: number,
  product_page_total: number,
  product_page_count: number,
  loading_next_product: boolean,

  brand_page: number,
  brand_page_total: number,
  brand_page_count: number,
  loading_next_brand: boolean,

  manufacturer_page: number,
  manufacturer_page_total: number,
  manufacturer_page_count: number,
  loading_next_manufacturer: boolean,

  category_page: number,
  category_page_total: number,
  category_page_count: number,
  loading_next_category: boolean,
}

export enum ProductContextActionTypes {
  SET_PRODUCTS = 'SET_PRODUCTS',
  SET_ALL_PRODUCTS = 'SET_ALL_PRODUCTS',
  SET_PAGED_PRODUCTS = 'SET_PAGED_PRODUCTS',
  SET_PAGED_MANUFACTURERS = 'SET_PAGED_MANUFACTURERS',
  SET_PAGED_CATEGORIES = 'SET_PAGED_CATEGORIES',
  SET_QUERY = 'SET_QUERY',
  SET_MANUFACTURERS = 'SET_MANUFACTURERS',
  SET_TOP_MANUFACTURERS = 'SET_TOP_MANUFACTURERS',
  SET_BRANDS = 'SET_BRANDS',
  SET_BRANDS_DICT = 'SET_BRANDS_DICT',
  SET_ROUTE_FULFILMENTS = 'SET_ROUTE_FULFILMENTS',
  SET_SEARCH_CONTEXT = 'SET_SEARCH_CONTEXT',
  SET_SEARCH_RESULT = 'SET_SEARCH_RESULT',
  SET_PRODUCT_VIEW = 'SET_PRODUCT_VIEW',
  SET_SELLER_PRODUCT = 'SET_SELLER_PRODUCT',
  SET_LOADING = 'SET_LOADING',
  SET_LOADING_NEXT_PRODUCT = 'SET_LOADING_NEXT_PRODUCT',
  SET_LOADING_NEXT_BRAND = 'SET_LOADING_NEXT_BRAND',
  SET_LOADING_NEXT_MANUFACTURER = 'SET_LOADING_NEXT_MANUFACTURER',
  SET_LOADING_NEXT_CATEGORY = 'SET_LOADING_NEXT_CATEGORY',
  CLEAR_ALL = 'CLEAR_ALL',
}

export type ProductContextActions =
  | { type: ProductContextActionTypes.CLEAR_ALL }
  | { type: ProductContextActionTypes.SET_PRODUCTS, payload: IProduct[] }
  | { type: ProductContextActionTypes.SET_ALL_PRODUCTS, payload: IProduct[] }

  | { type: ProductContextActionTypes.SET_PAGED_PRODUCTS, payload: IProductPagedData }
  | { type: ProductContextActionTypes.SET_PAGED_MANUFACTURERS, payload: IManufacturerPagedData }
  | { type: ProductContextActionTypes.SET_PAGED_CATEGORIES, payload: ICategoryPagedData }

  | { type: ProductContextActionTypes.SET_QUERY, payload: string }
  | { type: ProductContextActionTypes.SET_MANUFACTURERS, payload: IManufacturer[] }
  | { type: ProductContextActionTypes.SET_TOP_MANUFACTURERS, payload: IManufacturer[] }
  | { type: ProductContextActionTypes.SET_BRANDS, payload: IBrand[] }
  | { type: ProductContextActionTypes.SET_BRANDS_DICT, payload: { [_id: string]: IBrand } }
  | { type: ProductContextActionTypes.SET_ROUTE_FULFILMENTS, payload: any }
  | { type: ProductContextActionTypes.SET_SEARCH_CONTEXT, payload: any }
  | { type: ProductContextActionTypes.SET_SEARCH_RESULT, payload: any }
  | { type: ProductContextActionTypes.SET_PRODUCT_VIEW, payload: 'list' | 'grid' }
  | { type: ProductContextActionTypes.SET_SELLER_PRODUCT, payload: ISellerProduct[] }
  | { type: ProductContextActionTypes.SET_LOADING, payload: boolean}
  | { type: ProductContextActionTypes.SET_LOADING_NEXT_PRODUCT, payload: boolean }
  | { type: ProductContextActionTypes.SET_LOADING_NEXT_BRAND, payload: boolean }
  | { type: ProductContextActionTypes.SET_LOADING_NEXT_MANUFACTURER, payload: boolean }
  | { type: ProductContextActionTypes.SET_LOADING_NEXT_CATEGORY, payload: boolean }

export interface IProductContextValue {
  product_state: IProductContextState,
  product_dispatch: Dispatch<ProductContextActions>,
  product_fetch: () => any,
  fetch_next_product: () => any,
  fetch_next_manufacturer: () => any,
  fetch_next_category: () => any
}